// extracted by mini-css-extract-plugin
module.exports = {"button":"styles__button___2Fdfg","wrapper":"styles__wrapper___AyQrh"};